import axios from 'axios';
import {api} from '../constants/api';
import {errors as E} from 'common/constants/errors';

export const register = ({
                           email,
                           firstName,
                           lastName,
                           licenseNumber,
                           gender
                         }) => dispatch => {
  const data = {
    email,
    firstName,
    lastName,
    licenseNumber,
    gender
  };

  return axios.post(api.REGISTER, data)
    .then(response => {
      const {data} = response.data;
      if (data < 0) throw new Error(E.SERVER_ERROR);
    })
};
